import React from "react";
import { PATH_GARANTE_PRIVACY } from "../../../path";

export const itInformativa = (
  <>
    <h1>INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI mediante l’utilizzo della APP SURGERY TRACKER</h1>
    <h2>dell’IRCCS Ospedale Policlinico San Martino ai sensi dell'articolo 13 del Regolamento (UE) 2016/679</h2>
    <span>
      <p>
        Prima di procedere al trattamento dei dati, come richiesto dall’art. 13 del Regolamento (UE) 2016/679 del
        Parlamento Europeo e del Consiglio del 27 aprile 2016 (GDPR), si informa che i dati personali conferiti sono
        oggetto di trattamento, sia in forma cartacea sia elettronica per le finalità di seguito indicate.
      </p>
      <h3>Titolare del trattamento</h3>
      <p>
        Titolare del trattamento dei dati personali è l’IRCCS Ospedale Policlinico San Martino (di seguito “Titolare”),
        con sede in Largo Rosanna Benzi 10 – 16132 Genova. In tale veste è responsabile di garantire l’applicazione
        delle misure organizzative e tecniche necessarie e adeguate alla protezione dei dati personali.
      </p>
      <h3>Responsabile per la Protezione dei Dati</h3>
      <p>
        Il Titolare ha nominato un Responsabile della Protezione dei Dati (di seguito “RPD”), ai sensi degli artt. 37 e
        ss. del Regolamento, contattabile all’indirizzo email:{" "}
        <a href="mailto:dpo@hsanmartino.it">dpo@hsanmartino.it</a>
      </p>
      <h3>Finalità e base giuridica del trattamento</h3>
      <p>
        Il trattamento dei dati personali avverrà, per le finalità di seguito descritte, in conformità alla vigente
        normativa in materia di privacy, pertanto il Titolare si impegna a trattarli secondo i principi di correttezza,
        liceità, trasparenza, nel rispetto delle finalità di seguito indicate, raccogliendoli nella misura necessaria ed
        esatta per il trattamento, utilizzandoli solo da personale allo scopo autorizzato.
        <br />
        Il trattamento dei dati personali è finalizzato all’utilizzo della web app SURGERY TRACKER.
        <br />
        Per la finalità sopra descritta la base liceità del trattamento si rinviene nell’art. 6 par. 1 lettera e) GDPR,
        ossia nell’esecuzione di compiti di interesse pubblico o comunque connessi all'esercizio di pubblici poteri.
      </p>
      <h3>Categorie di dati personali</h3>
      <p>
        E’ necessario precisare che i servizi forniti dalla web app SURGERY TRACKER, nonché le caratteristiche e le
        funzioni della stessa non richiedono alcuna forma di registrazione degli utenti. Tuttavia, i sistemi informatici
        e le procedure software preposte al funzionamento di questa web app acquisiscono, nel corso del loro normale
        esercizio, alcuni dati personali la cui trasmissione è implicita nell'uso dei protocolli di comunicazione di
        Internet.
        <br />
        In questa categoria di dati rientrano gli indirizzi IP o i nomi a dominio dei computer e dei terminali
        utilizzati dagli utenti, gli indirizzi in dotazione Uri/Url (Uniform Resource Identifier/Locator) delle risorse
        richieste, l'orario della richiesta, il metodo utilizzato nel sottoporre la richiesta al server, la dimensione
        del file ottenuto in risposta, il codice numerico indicante lo stato della risposta data dal server (buon fine,
        errore, ecc.) e altri parametri relativi al sistema operativo e all'ambiente informatico dell'utente.
        <br />I dati trattati al fine di perseguire la finalità sopra descritta sono:
      </p>
      <ul>
        <li>Impronta del browser</li>
        <li>Marca modello e risoluzione/dimensioni del dispositivo</li>
        <li>Dati di navigazione internet</li>
      </ul>
      <h3>Modalità di trattamento e periodo di conservazione dei dati</h3>
      <p>
        I dati personali sono trattati con strumenti automatizzati e manuali per il tempo strettamente necessario a
        conseguire gli scopi per cui sono stati raccolti. Specifiche misure di sicurezza sono osservate per prevenire la
        perdita dei dati, usi illeciti o non corretti ed accessi non autorizzati.
      </p>
      <p>Per quanto concerne i dati di navigazione non persistono per più di sette giorni.</p>
      <h3>Ambito di conoscibilità dei dati</h3>
      <p>
        I dati personali, inoltre, potranno essere condivisi, per le sopra citate finalità, alle seguenti categorie di
        soggetti:
      </p>
      <ul>
        <li>Autorizzati al trattamento da parte del Titolare;</li>
        <li>
          Responsabili del trattamento, quali soggetti eventualmente incaricati dal Titolare per specifiche attività di
          trattamento.
        </li>
      </ul>
      <h3>Trasferimento dei dati all’estero</h3>
      <p>
        Non sono previsti trasferimenti di dati personali verso Paesi terzi (extra-UE) o organizzazioni internazionali
      </p>
      <h3>Diritti degli interessati</h3>
      <p>
        Gli interessati hanno il diritto di ottenere dal Titolare, nei casi previsti, l'accesso ai dati personali e la
        rettifica o la cancellazione degli stessi o la limitazione del trattamento che li riguarda o di opporsi al
        trattamento (artt. 15 e ss. del Regolamento).
        <br />
        Per esercitare tali diritti all’Ospedale Policlinico San Martino dovrà compilare una specifica istanza che potrà
        essere:
      </p>
      <ol style={{ listStyleType: "lower-alpha" }}>
        <li>Consegnata personalmente all’Ufficio Protocollo (Palazzo Amministrazione piano Terra), oppure</li>
        <li>
          Spedita tramite raccomandata all’indirizzo: Ufficio Protocollo Ospedale Policlinico San Martino – Largo
          Rosanna Benzi 10, 16132 – Genova oppure
        </li>
        <li>
          Spedita tramite PEC a <a href="mailto:protocollo@pec.hsanmartino.it">protocollo@pec.hsanmartino.it</a>{" "}
          riportando in Oggetto: Privacy esercizio dei diritti.
        </li>
      </ol>
      <p>
        L’interessato può inoltre proporre reclamo ad un'Autorità di Controllo (Autorità Garante per la protezione dei
        dati personali –{" "}
        <a href={PATH_GARANTE_PRIVACY} target="_blank" rel="noopener noreferrer">
          www.garanteprivacy.it
        </a>
        ).
      </p>
    </span>
  </>
);
